module.exports = __webpack_public_path__ + "img/keepLaptop.a6b2cfca.png";